export enum SearchParam {
  Page = 'page',
}
